import { hasRule, espaceBibliothequeRules as rules } from "@/utils/rulesHelper";

function buildMenu() {
  let children = []

  if (hasRule(rules.CAN_ACCESS_BIBLIOTHEQUE)) {
    children.push({ name: 'Prév. Collective', url: '/espace-bibliotheque/accueil', icon: 'fa fa-list-alt' });
    if (hasRule(rules.CAN_ACCESS_EPARGNE_RETRAITE)) { 
      children.push({ name: 'Epargne / Retraite', url: '/espace-bibliotheque/epargne-retraite', icon: 'fa fa-list-alt' });
    }
  }

  if (hasRule(rules.CAN_MANAGE_BIBLIOTHEQUE_TABLES)) { // hasRule(rules.CAN_CONFIGURE_CONSIGNES)
    let subChildren = [];
    if (hasRule(rules.CAN_MANAGE_CATEGORIE)) {
      subChildren.push({ name: 'Catégories', url: '/espace-bibliotheque/categorie', icon: 'fa fa-cog' });
      subChildren.push({ name: 'Sous-catégories', url: '/espace-bibliotheque/sous-categorie', icon: 'fa fa-cog' });
    }
    if (hasRule(rules.CAN_MANAGE_TYPE)) {
      subChildren.push({ name: 'Types', url: '/espace-bibliotheque/type-document', icon: 'fa fa-cog' });
    }
    if (hasRule(rules.CAN_MANAGE_RUBRIQUE)) {
      subChildren.push({ name: 'Rubriques', url: '/espace-bibliotheque/rubrique', icon: 'fa fa-cog' });
      subChildren.push({ name: 'Sous-rubriques', url: '/espace-bibliotheque/sous-rubrique', icon: 'fa fa-cog' });
    }
    children.push({ name: 'Paramétrage', url: '#', icon: 'fa fa-cogs', children: subChildren });
  }

  return children
}

let menu = {
  items: buildMenu(),
}

export default menu